import {Component, ElementRef, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {CockpitCard} from 'shared/dtos/cockpit-card';
import {CockpitKontrolleM2} from 'shared/dtos/cockpit-kontrolle/cockpit-kontrolle';
import {EinflussVonExtremwertenM2} from 'shared/dtos/cockpit-kontrolle/einfluss-von-extremwerten-m2';
import {MitarbeiterBase} from 'shared/dtos/mitarbeiterBase';
import {DataStorageService} from 'shared/services/data-storage.service';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';
import {CockpitContentComponent} from '../../../cockpit-shared/cockpit-content-component';
import {CurrentLocaleComponent} from 'shared/components/current-locale-component';

@Component({
  selector: 'app-chart-dialog-einfluss-von-extremwerten-m2',
  templateUrl: './chart-dialog-einfluss-von-extremwerten-m2.component.html',
  styleUrl: './chart-dialog-einfluss-von-extremwerten-m2.component.scss',
  standalone: false
})
export class ChartDialogEinflussVonExtremwertenM2Component
  extends CurrentLocaleComponent
  implements OnInit, CockpitContentComponent
{
  cockpitKontrolle: CockpitKontrolleM2;
  einflussVonExtremwerten: EinflussVonExtremwertenM2;
  mitarbeiters: MitarbeiterBase[];

  card: CockpitCard;
  crtLocale: string;

  tableHeaders = ['m2.sprint7.cockpit-kontrolle.einfluss-extremwerte.subtitle'];

  constructor(
    private readonly storage: DataStorageService,
    protected readonly translate: TranslateService,
    private readonly tableDataExport: TableExportService,
    private readonly element: ElementRef
  ) {
    super(translate);
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.cockpitKontrolle =
      (await this.storage.getCockpitKontrolle()) as CockpitKontrolleM2;
    this.mitarbeiters = await this.storage.getMitarbeiter();
    this.einflussVonExtremwerten =
      this.cockpitKontrolle?.einflussVonExtremwerten;

    this.translate.onLangChange.subscribe(translate => {
      this.crtLocale = translate.lang;
    });
    this.crtLocale = this.translate.currentLang;
  }

  downloadTable() {
    this.tableDataExport.exportHtmlTableInElement(
      this.element.nativeElement,
      this.card?.title
    );
  }
}
